module.exports = __webpack_public_path__ + "img/closed.44b6c37b.png";